import { toast } from "sonner";
import { Icon } from "@iconify/react";

const baseOptions = {
  duration: 3000,
};

const icons = {
  success: (
    <Icon icon="lets-icons:check-fill" width="22" height="22" />
  ),
  error: (
    <Icon icon="material-symbols:error" width="22" height="22" />
  ),
  warning: (
    <Icon icon="material-symbols:warning" width="22" height="22" />
  ),
};

const notify = ({ message, type = "info", options = {} }) => {
  if (!message) return;

  const toastType = toast[type] || toast;

  toastType(message, {
    ...baseOptions,
    icon: icons[type],
    ...options,
  });
};

export const notifyApi = (res) => {
  notify({
    message: res?.message,
    type: res?.success ? "success" : "error",
  });
};

export default notify;
